"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../checkbox/index.js");

var _radiomark = _interopRequireDefault(require("./radiomark.js"));

var _styledComponents = require("./styled-components.js");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Radio = function Radio(props) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn("This StyledRadio component will be deprecated in the next major version. Please\n      update your code to use the 'Radio' component instead. See examples at https://baseui.design/components/radio/.\n    ");
  }

  return _react.default.createElement(_index.Checkbox, _extends({
    overrides: {
      Root: _styledComponents.Root,
      Checkmark: _radiomark.default,
      Label: _styledComponents.Label,
      Input: _styledComponents.Input
    }
  }, props));
};

var _default = Radio;
exports.default = _default;